module.exports = __webpack_public_path__ + "img/13ne.76a3ce39.svg";